import * as React from "react";
function SvgHome(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M5 12v17h22V12"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M31 15L16 3 1 15M23 29V19h-8v10"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgHome);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
